import React, { Component } from 'react'
import Header from './components/header'
import Footer from './components/footer';
// import Comments from './components/news/comments'
import Content from './components/news/content'
// import Search from './components/news/search'
// import Category from './components/news/category'
import RecentPost from './components/news/recentPost'
// import Archive from './components/news/archive'
// import Tag from './components/news/tag';
// import TagShare from './components/news/tagShare';
// import { Link } from 'react-router-dom';
import PageTilte from './components/pageTilte';
import axios from 'axios';
import { constantApp } from '../../config/constant';


class NewsDetail extends Component {

    constructor(props) {
        super(props);
        const { match: { params } } = this.props;
        this.state = {
            idNews: params.id,// this.props.location.state.id,
            Title: '',
            DateSabt: '',
            Content: '',
            namFamil: '',
            isLoading: true,
        };
    }



    componentDidUpdate(prevProps) {
        if (prevProps.location.key !== this.props.location.key) {
            //  window.scrollTo(0, 0)
            window.location.reload();

        }
    }



    componentDidMount = async () => {

        // const { news } = this.props.location;
        // console.log('news : ', news)
        // if (!news) return this.props.history.push('/news');


        // const { match: { params } } = this.props;

        // console.log(params.id)
        // console.log(this.props.params.id)
        window.scrollTo(0, 0)
        const url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/News/Select_New_One.php`;

        const param = {
            idNews: this.state.idNews,
        }

        // const PROXY_URL = 'https://cors-anywhere.herokuapp.com/';

        let data = await axios.post(url, param)
            .then(function (response) {

                return response.data;
            })
            .catch(function (error) {
                // this.setState({ isNetworkError: true })
            });

        if (data !== undefined && data.length > 0) {
            let n = JSON.parse(JSON.stringify(data[0]));
            let Content = n["Content"];
            let Title = n["Title"];
            let DateSabt = n["DateSabt"];
            let namFamil = n["namFamil"];
            this.setState({
                Title,
                DateSabt,
                Content,
                namFamil,
                isLoading: false,
            })
        }

    }

    render() {

        return (
            <div >
                <Header />

                <PageTilte title={'خبرهای شرکت'} />

                <section className="blog-single section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-8 col-md-9 blog-single-content">



                                {this.state.isLoading ?
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyItems: 'center', justifyContent: 'center' }}>
                                        <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: 24 }}></i>
                                        <br />
                                        <p >در حال بارگزاری اطلاعات</p>
                                    </div>
                                    :

                                    <Content
                                        namFamil={this.state.namFamil}
                                        DateSabt={this.state.DateSabt}
                                        Title={this.state.Title}
                                        Content={this.state.Content}
                                        idNews={this.props.match.params.id}
                                    />
                                }


                                {/* <TagShare /> */}
                                {/* <Comments /> */}



                            </div>

                            <div className="blog-sidebar col col-lg-3 col-lg-offset-1 col-md-3 col-sm-5">
                                {/* <Search /> */}
                                {/* <Category /> */}
                                <RecentPost />
                                {/* <Archive /> */}
                                {/* <Tag /> */}

                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
};

export default NewsDetail; 